module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell",
    class: {
      'divide-line': _vm.divide
    },
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_c('div', {
    staticClass: "left",
    style: ({
      color: _vm.leftColor
    })
  }, [_vm._v(_vm._s(_vm.leftText))]), _vm._v(" "), _c('div', {
    staticClass: "right",
    style: ({
      color: _vm.rightColor
    })
  }, [_vm._v(_vm._s(_vm.rightText))]), _vm._v(" "), _c('div', {
    staticClass: "right-arr"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rightArraw),
      expression: "rightArraw"
    }],
    staticClass: "icon",
    style: ({
      color: _vm.rightColor
    })
  }, [_vm._v("")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a88a18ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/item-align-text-cell.vue
// module id = 884
// module chunks = 34